module.exports = __webpack_public_path__ + "img/151.6e611c63.jpg";